module.exports = __webpack_public_path__ + "static/media/montana.e2948c95.png";